import aboutimage from "../image/man-9252300_960_720.jpg";

export default function AboutSanatanSection() {
  return (
    <section className="py-5" style={{ background: "#fff" }}>
      <div className="container-fluid">
        <div className="row align-items-center">

          {/* Left Side Image */}
          <div className="col-md-6 position-relative">
            <img
              src={aboutimage}
              alt="Sanatan Dharma"
              className="img-fluid rounded shadow"
              style={{
                width: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />

            {/* Sanatan Badge */}
            <div
              className="position-absolute text-white text-center fw-bold shadow"
              style={{
                top: "50%",
                left: "-20px",
                transform: "translateY(-50%)",
                background: "#ff5e00",
                padding: "18px 22px",
                borderRadius: "8px",
              }}
            >
              <div style={{ fontSize: "26px", lineHeight: "26px" }}>5000+</div>
              <div style={{ fontSize: "10px", marginTop: "4px", lineHeight: "12px" }}>
                YEARS OF <br /> HERITAGE
              </div>
            </div>
          </div>

          {/* Right Side Content */}
          <div className="col-md-6 mt-4 mt-md-0">
            <h6 className="fw-bold" style={{ color: "#ff5e00", fontSize: "26px" }}>
              About Us
            </h6>

            <h2 className="fw-bold mb-3" style={{ color: "#ff5e00" }}>
              Sanatan Dharm Seva Sangh
            </h2>

            <p style={{ color: "#555", lineHeight: "1.7" }}>
              Sanatan Dharm Seva Sangh is dedicated to preserving and spreading
              the eternal knowledge and culture of Bharat.
              Our mission is to introduce the world to the timeless wisdom of
              the Vedas, Upanishads, Bhagavad Gita, Yoga, Ayurveda, and the core 
              principles of Sanatan Dharma. We aim to inspire spiritual growth, 
              cultural pride, and righteous living among all generations.
            </p>

            <ul className="list-unstyled mt-3 text-dark fw-medium">
              <li className="mb-2">
                <span style={{ color: "#ff5e00", fontSize: "18px" }}>➤</span> Study & promotion of Vedas, Gita, and Puranas
              </li>
              <li className="mb-2">
                <span style={{ color: "#ff5e00", fontSize: "18px" }}>➤</span> Cow protection & service to saints and society
              </li>
              <li className="mb-2">
                <span style={{ color: "#ff5e00", fontSize: "18px" }}>➤</span> Yoga, meditation & spiritual programs
              </li>
              <li className="mb-2">
                <span style={{ color: "#ff5e00", fontSize: "18px" }}>➤</span> Spreading Indian values & divine Sanatan culture
              </li>
            </ul>

            <button
              className="btn text-white fw-semibold mt-3"
              style={{
                background: "#ff5e00",
                borderRadius: "30px",
                padding: "10px 22px",
              }}
            >
              Explore More →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
